module.exports = __webpack_public_path__ + "img/AI智能.7fbdda88.png";